<template>
  <div class="header__profile profile">
    <div class="profile__dropdown" v-if="user.authenticated">
      <RoleSelect></RoleSelect>
    </div>
    <a href="" class="logout-btn link link--blue" v-on:click="logout()" v-if="user.authenticated"><span>{{
      $t('header.logout') }}&nbsp;</span><i class="fa fa-sign-out"></i><i class="icon icon--arrow"></i></a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RoleSelect from 'common/RoleSelect';

export default {
  computed: mapGetters({
    user: 'user/user/user',
  }),
  methods: {
    logout() {
      this.$store.dispatch('user/user/logout').then(() => {
        this.$router.push({ name: 'login' });
      });
    },
  },
  components: {
    RoleSelect,
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/app.scss';

.header__profile {
  padding-right: 30px;
  background-color: #F8F9F9;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  .profile__dropdown {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    width: calc(100% - 60.33px);
    width: -moz-calc(100% - 90.33px);
    width: -webkit-calc(100% - 60.33px);
    max-width: 376px;
    height: 100%;
    padding: 0 20px;

    @media screen and (max-width: 450px) {
      width: calc(100% - 14px);
      width: -moz-calc(100% - 14px);
      width: -webkit-calc(100% - 14px);
    }

    /*
    &:after {
      content: "";
      width: 6px;
      height: 5px;
      margin-left: 5px;
      background: url('~icons/dropdown.svg') 0 0 no-repeat;
    }
    */
    .profile__avatar {
      border: 1px #B8B4B2 solid;
      border-radius: 15px;
      width: 22px;
      height: 22px;
      margin-right: 14px;

      @media screen and (max-width: 450px) {
        display: none;
      }

    }
  }

  .logout-btn span {

    @media screen and (max-width: 450px) {
      display: none;
    }

  }

  .logout-btn i.fa {
    font-size: 14px;
    display: none;

    @media screen and (max-width: 450px) {
      display: inline-block;
    }

  }

  .logout-btn i.icon {

    @media screen and (max-width: 450px) {
      display: none;
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/components/common/ProfileHeader.vue